import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { TextCTA, M2A, ButtonLink } from 'www-cms';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-text-cta',
  imports: [CommonModule, ButtonLinkComponent, DirectusDirective],
  templateUrl: './text-cta.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextCTAComponent extends BaseBuildingBlockComponent {
  @Input({ required: true }) textCTAData!: TextCTA;

  buttons(_: number, item: M2A<ButtonLink>) {
    return item.item.id;
  }

  override getBgClass(): LastItemBgClass {
    return this.textCTAData.darkBackground
      ? 'bg-ss-www-background'
      : 'bg-white';
  }
}
